import React, { useState, useEffect } from "react";
import "../../style/Liste.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet";

const API_URL = process.env.REACT_APP_API_URL;

function ListeVerriers() {
  const [verriers, setVerriers] = useState([]);

  useEffect(() => {
    function getVerriers() {
      axios
        .get(`${API_URL}/api/verriers`)
        .then((res) => res.data)
        .then((data) => {
          setVerriers(data);
        });
    }

    getVerriers();
  }, []);

  return (
    <div className="listeMain">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Liste des verriers</title>
      </Helmet>
      <h1>Liste des verriers</h1>
      <div>
        {verriers ? (
          verriers.map((verrier) => {
            return (
              <Link to={`/fournisseurs-verres/${verrier.id}`}>
                <img
                  src={`${API_URL}/images/fournisseurs-verres/${verrier.id}.png`}
                  alt={verrier.nom}
                  className="listeLogo"
                />
              </Link>
            );
          })
        ) : (
          <li>Loading</li>
        )}
      </div>
    </div>
  );
}

export default ListeVerriers;
